var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-radio-group',{staticClass:"radio-tree",attrs:{"mandatory":false},on:{"change":_vm.changed},model:{value:(_vm.input),callback:function ($$v) {_vm.input=$$v},expression:"input"}},[_c('v-treeview',{attrs:{"items":_vm.items,"dense":"","shaped":"","hoverable":""},on:{"update:open":_vm.opened},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [(open||!item.children.length)?_c('v-icon',[_vm._v("folder_open")]):_c('v-icon',[_vm._v("folder")])]}},{key:"label",fn:function(ref){
var item = ref.item;
return [_c('v-radio',{attrs:{"label":item.title,"value":_vm.valueFor(item)}})]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }